import formatDecimalNumber from '../formatDecimalNumber';

export default function formatPercent(value: number, digit: number, formatMinus?: boolean): string {
  const percentage = value * 100;
  const formatted = formatDecimalNumber(Math.abs(percentage), digit);

  if (formatMinus && percentage < 0) {
    return `(${formatted}%)`;
  }

  return `${formatDecimalNumber(percentage, digit)}%`;
}
